export const irAInicioDeLogin = () => {
  window.location.href = process.env.REACT_APP_URL_INICIAR_SESION || '';
};
